import { Box, FormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const ITEM_HEIGHT = 32
const ITEM_PADDING_TOP = 8

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small}px;

  .label-text {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 22px;
  }
`

export const IntegrationsFormControl = styled(FormControl)<{ isselected?: string; isopen?: string }>`
  background: transparent;
  outline: none;
  min-width: 162px;
  height: 48px;
  display: flex;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.dropdownBorder};

  ${({ isopen }) =>
    isopen === 'true' &&
    `
        border-color: ${theme.colors.cta};
    `};

  .is-open {
    path {
      stroke: ${theme.colors.cta};
    }
  }

  .MuiOutlinedInput-root {
    width: 162px;
    height: 48px;
    background: transparent;
    border: 0;
    font-family: ${theme.typography.fontFamily.primary};
    color: ${({ isselected }) =>
      isselected && isselected === 'true' ? theme.colors.cta : theme.colors.devicesSecondaryText};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    gap: ${theme.spacing.xSmall}px;
    margin-top: -1px;

    > * {
      border: none !important;
      outline: none !important;
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none !important;
    }

    .MuiSelect-select {
      width: 162px;
      padding-right: 36px;
      color: ${({ isselected }) =>
        isselected && isselected === 'true' ? theme.colors.cta : theme.colors.devicesSecondaryText};
    }
  }

  &:hover {
    border-color: #6c5b67;

    html[data-theme='light'] & {
      border-color: ${theme.colors.dropdownBorder};
    }

    svg {
      path {
        stroke: ${theme.colors.foreground};
      }
    }

    .MuiOutlinedInput-root {
      color: ${theme.colors.cta};
    }
  }

  svg {
    top: calc(50% - 0.6em);
    right: ${theme.spacing.small}px;
  }

  fieldset {
    padding: 0;
  }
`

export const CategoryMenuProps = {
  PaperProps: {
    sx: {
      background: theme.colors.borderMedium,
      "html[data-theme='light'] &": {
        background: theme.colors.surfaceContainerBackground
      },
      borderRadius: theme.attributes.borderRadius.tertiary,
      boxShadow: '0px 4px 8px 0px rgba(30, 26, 29, 0.20)',
      width: '244px',
      marginTop: `${theme.spacing.xSmall}px`,

      '.MuiList-root': {
        padding: '0',

        '.list-wrapper': {
          maxHeight: '190px',
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          marginRight: '6px',

          '&::-webkit-scrollbar': {
            width: '4px',
            height: '4px'
          },

          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            borderRadius: theme.attributes.borderRadius.secondary
          },

          '&::-webkit-scrollbar-thumb': {
            background: theme.colors.surfaceContainerBackground,
            "html[data-theme='light'] &": {
              background: theme.colors.borderMedium
            },
            borderRadius: '4px'
          }
        }
      },

      '.MuiMenuItem-root': {
        height: '38px',
        paddingLeft: `${theme.spacing.small}px`,
        paddingRight: `${theme.spacing.medium}px`,

        img: {
          marginRight: `${theme.spacing.xSmall}px`
        },

        '&:hover': {
          background: `${theme.colors.menuItemHover} !important`
        },

        '.MuiCheckbox-root': {
          paddingRight: `${theme.spacing.xSmall}px`,
          paddingLeft: 0,

          '&.Mui-checked svg path': {
            stroke: theme.colors.checkboxChecked
          }
        },

        '.MuiListItemText-root .MuiTypography-root': {
          color: theme.colors.menuItemText,
          fontFamily: theme.typography.fontFamily.primary,
          fontSize: theme.typography.fontSize.large,
          fontStyle: 'normal',
          fontWeight: theme.typography.fontWeight.bold,
          lineHeight: '22px'
        },

        display: 'flex',
        alignItems: 'center',
        width: '100%',

        '.image-wrapper': {
          display: 'flex',

          '> img': {
            width: '18px',
            height: '18px',
            boxShadow: theme.attributes.boxShadow.chipCircle,
            margin: '-4.5px',
            borderRadius: theme.attributes.borderRadius.circle,

            '&:nth-of-type(1)': {
              zIndex: 10
            },
            '&:nth-of-type(2)': {
              zIndex: 9
            },
            '&:nth-of-type(3)': {
              zIndex: 8
            },
            '&:nth-of-type(4)': {
              zIndex: 7
            },
            '&:nth-of-type(5)': {
              zIndex: 6
            },
            '&:nth-of-type(6)': {
              zIndex: 5
            },
            '&:nth-of-type(7)': {
              zIndex: 4
            }
          }
        },

        '.textWrapper': {
          marginLeft: '13px'
        }
      },

      '&::-webkit-scrollbar': {
        display: 'none'
      }
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const,
  getContentAnchorEl: null
}
